import autosize from 'autosize';

import Component from '../component';

export default class AutoSizeTextarea extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.bindEvents();
  }

  bindEvents() {
    autosize(this.$element);

    this.handleResized = this.handleResized.bind(this);

    this.$element.on('autosize:resized', this.handleResized);
  }

  unbindEvents() {
    this.$element.off('autosize:resized', this.handleResized);

    autosize.destroy(this.$element);
  }

  handleResized() {
    window.$window.trigger('resize');
  }
}
